import { ScrollArea, ScrollBar } from './ui/scroll-area';

const CATEGORIES = [
  "Todos",
  "Cabos",
  "Carregadores",
  "Powerbank",
  "Fones",
  "Acessórios de Informática",
  "Cartões de Memória",
  "Produtos Seminovos",
  "Aluguel de Starlink Mini"
];

export const CategoryFilter = ({ selected, onSelect }) => {
  return (
    <div className="w-full" data-testid="category-filter">
      <ScrollArea className="w-full whitespace-nowrap">
        <div className="flex gap-2 pb-4">
          {CATEGORIES.map((category) => (
            <button
              key={category}
              onClick={() => onSelect(category)}
              className={`category-pill flex-shrink-0 ${
                selected === category
                  ? 'category-pill-active'
                  : 'category-pill-inactive'
              }`}
              data-testid={`category-${category.toLowerCase().replace(/\s/g, '-')}`}
            >
              {category}
            </button>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </div>
  );
};

export default CategoryFilter;
